<h4>{{ title }}</h4>

<div class="form-wrapper">
  <lsz-edit-form-header
    [headerText]="'Budgets'"
    [numEntries]="budgetsFormArray?.controls?.length || 0"
    [editMode]="isEditing"
    (clickEdit)="toggleEditing()"
    (clickEditDone)="save()"></lsz-edit-form-header>

  <p *ngIf="isEditing">
    <fa-icon [icon]="faInfoCircle" />
    Die untere Grenze jedes Budgets wird automatisch aus der oberen Grenze des vorherigen Budgets berechnet.<br />
    Das erste Budget hat keine untere Grenze. Das letzte Budget hat keine obere Grenze.
  </p>

  <form [formGroup]="budgetForm">
    <table [class.editMode]="isEditing">
      <thead>
        <tr>
          <th>Name</th>
          <th>Untere Grenze</th>
          <th>Obere Grenze</th>
        </tr>
      </thead>
      <tbody formArrayName="budgetsArray">
        <tr
          *ngFor="let budgetGroup of budgetsFormArray.controls; let i = index; let isLast = last; let isFirst = first"
          [formGroupName]="i">
          <td>
            <!-- Name is always read-only -->
            <span>{{ budgetGroup.get('name').value }}</span>
          </td>
          <td>
            <!-- LowerLimit is derived from previous budget's upperLimit, except first budget -->
            <div *ngIf="!isFirst; then hasLowerLimit; else hasNoLowerLimit"></div>
            <ng-template #hasLowerLimit>{{ getUpperLimitFromPreviousOrNull(i) | number: '1.0' }}</ng-template>
            <ng-template #hasNoLowerLimit>-</ng-template>
          </td>
          <td>
            <!-- Last budget's upperLimit is null and readonly -->
            <div *ngIf="isEditing && !isLast">
              <input
                type="number"
                formControlName="upperLimit"
                [min]="minValue"
                [max]="maxValue" />
              <div
                *ngIf="budgetGroup.get('upperLimit').invalid"
                class="input-error">
                <div *ngIf="budgetGroup.get('upperLimit').errors?.required">Eine obere Grenze ist erforderlich.</div>
                <div *ngIf="budgetGroup.get('upperLimit').errors?.min">
                  <ng-template [ngIf]="!isFirst">
                    Die obere Grenze muss größer sein als die untere Grenze ({{ getUpperLimitFromPreviousOrNull(i) }}).
                    <br />
                  </ng-template>
                  Die obere Grenze muss größer sein als das Minimum ({{ minValue - 1 }}).
                </div>
                <div *ngIf="budgetGroup.get('upperLimit').errors?.max">
                  Die obere Grenze muss kleiner sein als das Maximum ({{ maxValue }}).
                </div>
              </div>
            </div>
            <span *ngIf="!isEditing && !isLast">{{ budgetGroup.get('upperLimit').value | number: '1.0' }}</span>
            <span *ngIf="isLast">-</span>
          </td>
        </tr>
        <tr *ngIf="budgetsFormArray.controls.length === 0">
          <td colspan="3">Keine Budgets vorhanden</td>
        </tr>
      </tbody>
    </table>
  </form>
</div>
